import {sidenav} from './sidenav.directive';
import {SidenavController} from './sidenavController';
import './sidenav.scss';

import {slideToggle, slideable} from '../../../core/angularSlideable';

let appModule = angular.module('deliveryCreate.app');

appModule.directive('sidenav', sidenav);
appModule.controller('SidenavController', SidenavController);
appModule.directive('slideToggle', slideToggle);
appModule.directive('slideable', slideable);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/navigation/sidenav/bootstrap.ts
 **/